<template>
  <div class="accounts-heading" :class="{ 'accounts-heading--dark': $vuetify.theme.dark }">
    <div class="accounts-heading__title">
      <v-icon size="22">mdi-chart-bar</v-icon>
      <span>Live Accounts</span>
    </div>

    <v-menu offset-y bottom left>
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="accounts-heading__button" small elevation="0" v-bind="attrs" v-on="on">
          <v-icon left size="17">mdi-plus</v-icon>
          Create Account
          <v-icon right size="17">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense class="accounts-heading__menu">
        <v-list-item v-for="item in items" :key="item.text" :to="item.link">
          <v-list-item-icon><v-icon size="18">{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>{{ item.text }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "LiveAccountsHeading",
  data: () => ({
    items: [
      { text: "Create Live Account", icon: "mdi-signal", link: "/create-live-account" },
      { text: "Create Investor Account", icon: "mdi-currency-usd", link: "/create-investor-account" },
      { text: "Create Manager Account", icon: "mdi-account-tie", link: "/create-manager-account" },
    ],
  }),
};
</script>

<style scoped>
.accounts-heading {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  color: #111b3a;
}
.accounts-heading__title { display: flex; align-items: center; gap: 10px; font-size: 16px; font-weight: 700; }
.accounts-heading__title .v-icon { color: #d99a00; }
.accounts-heading--dark { color: #f4f7ff; }
.accounts-heading--dark .accounts-heading__title .v-icon { color: #ffc400; }
.accounts-heading__button {
  border-radius: 4px !important;
  border: 1px solid #d99a00 !important;
  background: transparent !important;
  color: #b47f00 !important;
  box-shadow: none !important;
  font-size: 11px;
  letter-spacing: 0;
  text-transform: none;
}
.accounts-heading--dark .accounts-heading__button { color: #ffc400 !important; }
.accounts-heading__button .v-icon { color: inherit !important; }
.accounts-heading__menu { min-width: 220px; }
@media (max-width: 500px) {
  .accounts-heading { align-items: flex-start; padding: 8px 0; flex-direction: column; gap: 10px; }
}
</style>
